export default __webpack_public_path__ + "static/media/Michael-Mcdonald.d85db0dc.jpg";